<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear Producto / Examen</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitProduct">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">SKU (Código único)</label>
                                    <argon-input v-model="product.sku" type="text" placeholder="Ej: LAB-HMG01" />
                                    <small v-if="submitted && v$.product.sku.$error" class="text-danger">SKU requerido y único</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre</label>
                                    <argon-input v-model="product.name" type="text" placeholder="Ej: Hemograma Completo" />
                                    <small v-if="submitted && v$.product.name.$error" class="text-danger">Nombre requerido</small>
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label class="form-control-label">Descripción</label>
                                    <argon-input v-model="product.description" type="textarea" rows="3" placeholder="Descripción detallada del producto o análisis" />
                                    <small v-if="submitted && v$.product.description.$error" class="text-danger">Descripción requerida</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-label mb-1">Unidad de Medida</label>
                                    <ArgonLookup
                                        :options="units"
                                        v-model="unitSelected"
                                        track-by="id"
                                        display-key="name"
                                        placeholder="Seleccione la unidad..."
                                    >
                                        <template #option="{ option }">
                                            <span>
                                                <span class="font-weight-bold">{{ option.code }}</span>
                                                ({{ option.name }})
                                            </span>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="loadingUnits" class="text-muted">Cargando unidades...</small>
                                    <small v-if="submitted && v$.product.unit.$error" class="text-danger">Unidad requerida.</small>
                                </div>



                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Precio de Costo</label>
                                    <argon-input v-model="product.price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.price.$error" class="text-danger">Precio de costo requerido y mayor a 0</small>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Precio de Venta</label>
                                    <argon-input v-model="product.sale_price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.sale_price.$error" class="text-danger">Precio de venta requerido y mayor a 0</small>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="product.state">
                                        <option value="">Seleccione un estado</option>
                                        <option :value="1">Activo</option>
                                        <option :value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.product.state.$error" class="text-danger">Estado requerido</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Gravable (Impuesto)</label>
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="product.taxable"
                                            id="taxable"
                                        />
                                        <label class="form-check-label" for="taxable">Sí, aplica impuestos</label>
                                    </div>
                                    <div class="form-check mt-2">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="product.is_lab_test"
                                            id="is_lab_test"
                                        />
                                        <label class="form-check-label" for="is_lab_test">Es Examen de Laboratorio (Servicio)</label>
                                    </div>
                                </div>


                                <div class="col-md-12 mt-3 text-center">
                                    <div>
                                        <label class="form-control-label">Foto del producto</label>
                                    </div>
                                    <div class="image-upload-area mx-auto" @click="uploadPhoto()">
                                        <img :src="product.photo_url || fileUpload" alt="Foto producto" class="img-thumbnail" style="max-width:200px; height: auto; display: block;" @error="handleImageError" />
                                        <input type="file" style="display: none !important;" ref="productPhotoFile" accept="image/jpeg, image/png" @change="onFileChange($event)">
                                    </div>
                                    <small class="text-muted d-block mt-1">Haz clic en la imagen para subir una foto.</small>
                                </div>
                            </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Producto
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template><script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import fileUpload from '@/assets/img/uploadfile.jpg';

const companyId = localStorage.getItem('companyId');

export default {
    name: "CreateProduct",
    components: { ArgonInput, ArgonButton, ArgonLookup },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            fileUpload,
            submitted: false,
            loadingCategories: false,
            loadingUnits: false,

            // 🛑 LOOKUP MODELS 🛑
            categorySelected: null,
            unitSelected: null,
            categories: [], // Lista de opciones para categoría
            units: [],      // Lista de opciones para unidades

            product: {
                sku: '',
                name: '',
                description: '',
                unit: null,
                price: 0.00,
                sale_price: 0.00,
                taxable: true,
                is_lab_test: false,
                state: 1,
                photo_url: null,
                company: parseInt(companyId)
            }
        };
    },
    validations() {
        return {
            product: {
                sku: { required: helpers.withMessage('SKU requerido', required) },
                name: { required: helpers.withMessage('Nombre requerido', required) },
                description: { required: helpers.withMessage('Descripción requerida', required) },
                unit: { required: helpers.withMessage('Unidad requerida', required) },
                price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                sale_price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                state: { required: helpers.withMessage('Estado requerido', required) },
            }
        };
    },
    watch:{
        // 🛑 Mapeo de Lookups 🛑
        categorySelected(newVal){
            this.product.category = newVal ? newVal.id : null;
        },
        unitSelected(newVal){
            this.product.unit = newVal ? newVal.id : null;
        }
    },
    methods: {

        // 🛑 I. FETCH DE DATOS MAESTROS 🛑
        async fetchUnits(config){
            this.loadingUnits = true;
            try {
                // Endpoint: /units?company=ID
                const result = await axios.get(this.$store.state.apiURL + `units?company=${companyId}`, config);
                // Mapear a formato ArgonLookup: { id, code, name }
                this.units = result.data.map(item => ({ id: item.id, code:item.code, name:item.name, value: item.id }));
            } catch (error) {
                this.handleSessionError(error);
            } finally {
                this.loadingUnits = false;
            }
        },
        async fetchCategories(config){
            this.loadingCategories = true;
            try {
                // Endpoint: /products_category?company=ID
                const result = await axios.get(this.$store.state.apiURL + `products_category?company=${companyId}`, config);
                // Mapear a formato ArgonLookup: { id, name }
                this.categories = result.data.map(item => ({ id: item.id, name: item.name, value: item.id }));
            } catch (error) {
                this.handleSessionError(error);
            } finally {
                this.loadingCategories = false;
            }
        },

        uploadPhoto() {
            this.$refs.productPhotoFile.click();
        },

        onFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const self = this;
            let formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', file.name);

            axios.post(this.$store.state.fileURL, formData,
                {
                headers: {
                    "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function(result){
                self.product.photo_url = result.data.url;
                Swal.fire('Subida exitosa', 'La imagen fue cargada al servidor.', 'success');
            }).catch(err => {
                console.error("Error al subir archivo:", err.response || err);
                Swal.fire('Error', 'Fallo al subir el archivo.', 'error');
                self.product.photo_url = null;
            });
        },
        handleImageError(event) {
            event.target.src = this.fileUpload;
        },

        async submitProduct() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({ title: 'Datos inválidos', text: 'Por favor, revisa los campos requeridos.', icon: 'warning', confirmButtonColor: '#0b9257' });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

            // Aseguramos que los IDs sean enteros si es necesario
            const payload = {
                ...this.product,
                taxable: this.product.taxable ? 1 : 0, // Convertir bool a TINYINT(1)
                is_lab_test: this.product.is_lab_test ? 1 : 0 // Convertir bool a TINYINT(1)
            };

            try {
                await axios.post(`${apiURL}products`, payload, config);

                Swal.fire({
                    title: 'Producto creado',
                    text: `El ítem fue registrado. Tipo: ${this.product.is_lab_test ? 'Examen Clínico' : 'Producto Normal'}.`,
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/products');
                });

            } catch (err) {
                console.error('Error al guardar producto:', err.response || err);
                const errorText = (err.response && err.response.data && err.response.data.error)
                                 ? err.response.data.error : 'No se pudo guardar el producto. Verifique el SKU.';
                Swal.fire({ title: 'Error', text: errorText, icon: 'error', confirmButtonColor: '#0b9257' });
            }
        },

        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
    async mounted(){
        const token = localStorage.getItem("accessToken");
        const config = { headers: { 'Authorization': `Bearer ${token}` } };

        // Carga de lookups al montar
        await Promise.all([
            this.fetchUnits(config),
            this.fetchCategories(config)
        ]);
    }
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
</style>